import React, { createContext, useContext, useState, useEffect } from "react";
import useLogin from "../../hooks/useLogin";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const { user: loginUser, isLoading, error, login: wsLogin } = useLogin();
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [groupId, setGroupId] = useState(null);
  const [roleId, setRoleId] = useState(null);

  // Check for existing authentication on component mount
  useEffect(() => {
    const storedToken = localStorage.getItem('authToken');
    const storedUser = localStorage.getItem('user');
    const storedGroupId = localStorage.getItem('groupId');
    const storedRoleId = localStorage.getItem('roleId');
    
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
      setGroupId(storedGroupId);
      setRoleId(storedRoleId);
    }
  }, []);

  const login = async (email, password) => {
    const response = await wsLogin(email, password);

    if (response && response.success) {
      const adminData = {
        admin_id: response.admin_id,
        group_id: response.group_id,
        role_id: response.role_id,
      };
      
      // Update state
      setUser(adminData);
      setToken(response.token);
      setGroupId(response.group_id);
      setRoleId(response.role_id);
      
      // Store in localStorage to persist across refreshes
      localStorage.setItem('authToken', response.token);
      localStorage.setItem('user', JSON.stringify(adminData));
      localStorage.setItem('groupId', response.group_id);
      localStorage.setItem('roleId', response.role_id);
      
      return true;
    }
    return false;
  };

  const logout = () => {
    // Clear state
    setUser(null);
    setToken(null);
    setGroupId(null);
    setRoleId(null);
    
    // Remove from localStorage
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('groupId');
    localStorage.removeItem('roleId');
    
    window.location.reload();
  };

  return (
    <AuthContext.Provider value={{ 
      user, 
      token, 
      groupId, 
      roleId, 
      isLoading, 
      error, 
      login, 
      logout,
      isAuthenticated: !!token // Add this helper property
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;